export default __webpack_public_path__ + "static/media/head04_ja_sp.e4519855.png";